module.exports = __webpack_public_path__ + "assets/fonts/b7b38c4ecc14c09049099dc326d171d3.png";